var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "psi-form-layout-section",
    {
      attrs: {
        title: "Ring Central",
        icon: "mdi-phone-log-outline",
        "btn-label": "Save Settings",
        "btn-icon": "mdi-phone-log-outline"
      }
    },
    [
      _c("psi-form-section", {
        attrs: {
          value: _vm.data,
          name: "update-ring-central",
          label: "",
          fields: _vm.fields,
          color: "secondary"
        },
        on: { input: _vm.update }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }